import {ShowcaseItem, ShowcaseItemDraft} from "../types";
import React, {ReactElement} from "react";
import {Button, Grid, TextareaAutosize, TextField, Typography, useMediaQuery, useTheme} from "@mui/material";
import {StyledBoxColumn} from "shared/StyledComponents";
import {ShowcaseItemImage} from "./ShowcaseItemImage";
import {App} from "../App";
import {DIVIDER_BLACK, PAGE_FRAGMENT_WIDTH, PD_LG, PD_SM} from "shared/dimens";
import {StoredDataFileUploadFragment} from "shared/StoredDateFileUploadFragment";
import {DesktopFile} from "shared/files";

function EditShowcaseItem_<T extends ShowcaseItem>(props: { showcaseItem: T, setShowcaseItem: (showcaseItem: T) => void }): ReactElement {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  return <Grid container spacing={2}>
    <Grid item xs={12} sm={4}>
      <StyledBoxColumn style={{alignItems: "center"}}>
        <ShowcaseItemImage showcaseItem={props.showcaseItem} style={{maxWidth: !sm ? 128 : 240}}/>
        <Button onClick={() => App.CONTEXT.showDialog(null, () => <StyledBoxColumn
          style={{width: "90vw", maxWidth: PAGE_FRAGMENT_WIDTH}}>
          <StoredDataFileUploadFragment
            deferUpload
            mimeTypes={["image/*"]}
            storedDataSource={"showcaseItem-covers"}
            onSelectionChanged={(urls: string[], files: DesktopFile[]) => {
              const showcaseItem = props.showcaseItem.cloneShowcaseItem() as T;
              showcaseItem.coverImageUrl = urls[0];
              if (showcaseItem instanceof ShowcaseItemDraft) {
                (showcaseItem as ShowcaseItemDraft).coverImageBlob = files[0].file.blob;
              }
              props.setShowcaseItem(showcaseItem);
            }}/>
        </StyledBoxColumn>)}>
          Change
        </Button>
      </StyledBoxColumn>
    </Grid>
    <Grid item xs={12} sm={8}>
      <StyledBoxColumn style={{width: "100%", gap: PD_LG}}>
        <StyledBoxColumn>
          <Typography>Name</Typography>
          <TextField
            placeholder={"Item Name"}
            style={{border: DIVIDER_BLACK}}
            value={props.showcaseItem.title}
            onChange={event => {
              const showcaseItem = props.showcaseItem.cloneShowcaseItem() as T;
              showcaseItem.title = event.target.value;
              props.setShowcaseItem(showcaseItem);
            }}/>
        </StyledBoxColumn>
        <StyledBoxColumn>
          <Typography>Description</Typography>
          <TextareaAutosize
            placeholder="Write something about this item..."
            style={{padding: PD_SM, fontSize: "125%", fontFamily: "sans-serif", maxHeight: 400}}
            minRows={3}
            value={props.showcaseItem.description}
            onChange={event => {
              const showcaseItem = props.showcaseItem.cloneShowcaseItem() as T;
              showcaseItem.description = event.target.value;
              props.setShowcaseItem(showcaseItem);
            }}/>
        </StyledBoxColumn>
      </StyledBoxColumn>
    </Grid>
  </Grid>;
}

export const EditShowcaseItem = EditShowcaseItem_<ShowcaseItem>;
export const EditShowcaseItemDraft = EditShowcaseItem_<ShowcaseItemDraft>;